// Collection toolbar filter toggle functionality
document.addEventListener('DOMContentLoaded', () => {
  // Helper function to setup toggle functionality
  const setupFilterToggle = (filterContainer, toggleClass, selectClass) => {
    if (!filterContainer) return;

    const toggleButton = filterContainer.querySelector(toggleClass);
    const selectElement = filterContainer.querySelector(selectClass);
    const wrapper = filterContainer.querySelector(
      '.collection-toolbar__sort-wrapper'
    );

    if (!toggleButton || !selectElement || !wrapper) return;

    // Toggle select visibility when button is clicked
    toggleButton.addEventListener('click', () => {
      const isExpanded = toggleButton.getAttribute('aria-expanded') === 'true';

      toggleButton.setAttribute('aria-expanded', !isExpanded);
      wrapper.setAttribute('aria-expanded', !isExpanded);

      if (!isExpanded) {
        selectElement.classList.add('is-visible');
        selectElement.focus();
      } else {
        selectElement.classList.remove('is-visible');
      }
    });

    // Handle keyboard navigation
    selectElement.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        e.preventDefault();
        toggleButton.setAttribute('aria-expanded', 'false');
        wrapper.setAttribute('aria-expanded', 'false');
        selectElement.classList.remove('is-visible');
        toggleButton.focus();
      }
    });

    // Close when select loses focus
    selectElement.addEventListener('blur', () => {
      setTimeout(() => {
        if (!selectElement.contains(document.activeElement)) {
          toggleButton.setAttribute('aria-expanded', 'false');
          wrapper.setAttribute('aria-expanded', 'false');
          selectElement.classList.remove('is-visible');
        }
      }, 100);
    });
  };

  // Setup flavor filter toggle
  const flavorFilter = document.querySelector(
    '.collection-toolbar__flavor-filter'
  );
  setupFilterToggle(
    flavorFilter,
    '.collection-toolbar__flavor-toggle',
    '.collection-toolbar__flavor-select'
  );

  // Setup sort filter toggle
  const sortFilter = document.querySelector('.collection-toolbar__sort-filter');
  setupFilterToggle(
    sortFilter,
    '.collection-toolbar__sort-toggle',
    '.collection-toolbar__sort-select'
  );
});
